(function () {
  const TEXT_ADD = 'Añadir al carrito';
  const TEXT_BACK = 'Regresar a seleccionar opciones';

  const SECTION_SELECTORS = [
    '[id*="accordion_content"]',
    '[id*="judge_me_reviews"]',
    '[id*="faq"]'
  ];

  let userHasInteractedWithVariants = false;
  let stickyInitialized = false;
  let visibleSections = new Set();

  /* ===============================
     HELPERS
  =============================== */
  function updateCTA() {
    const desktopBtn = document.getElementById('pdp-desktop-cta');
    const mobileBtn = document.getElementById('pdp-mobile-cta');
    if (!desktopBtn || !mobileBtn) return;

    const text = userHasInteractedWithVariants ? TEXT_BACK : TEXT_ADD;
    desktopBtn.textContent = text;
    mobileBtn.textContent = text;
  }

  function scrollToOptions() {
    const target =
      document.querySelector('[name^="options"]') ||
      document.querySelector('.product-form__input');

    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  /* ===============================
     WAIT FOR SECTIONS
  =============================== */
  function waitForSections(callback, retries = 20) {
    const sections = SECTION_SELECTORS
      .map(sel => document.querySelector(sel))
      .filter(Boolean);

    if (sections.length) {
      callback(sections);
      return;
    }

    if (retries > 0) {
      setTimeout(() => waitForSections(callback, retries - 1), 250);
    }
  }

  /* ===============================
     OBSERVER (ÚNICA FUENTE DE VERDAD)
  =============================== */
  function observeSections() {
    waitForSections((sections) => {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach(entry => {
            entry.isIntersecting
              ? visibleSections.add(entry.target)
              : visibleSections.delete(entry.target);
          });

          const shouldShow = visibleSections.size > 0;

          // 👉 ÚNICA CLASE QUE CONTROLA TODO
          document.body.classList.toggle('pdp-sticky-active', shouldShow);

          if (shouldShow && !stickyInitialized) {
            initSticky();
          }
        },
        {
          threshold: 0.15,
          rootMargin: '0px 0px -30% 0px',
        }
      );

      sections.forEach(section => observer.observe(section));
    });
  }

  /* ===============================
     INIT STICKY (SIN .show)
  =============================== */
  function initSticky() {
    stickyInitialized = true;

    const sticky = document.getElementById('pdp-sticky-bar');
    if (!sticky) return;
    // Nada más que inicializar
  }

  /* ===============================
     VARIANT INTERACTION
  =============================== */
  function observeVariantInteraction() {
    const form = document.querySelector('form[action^="/cart/add"]');
    if (!form) return;

    form.addEventListener('change', () => {
      if (!userHasInteractedWithVariants) {
        userHasInteractedWithVariants = true;
        updateCTA();
      }
    });
  }

  /* ===============================
     PILL SCROLL
  =============================== */
  function bindPillScroll() {
    const pills = document.querySelectorAll('.pdp-pill');
    if (!pills.length) return;

    pills.forEach(pill => {
      pill.addEventListener('click', () => {
        const targetId = pill.getAttribute('data-target');
        if (!targetId) return;

        // Buscar la sección correspondiente
        let targetSection = document.querySelector(`[id*="${targetId}"]`);
        // ConvertMate 20-oct-2026: «Beneficios» apuntaba a «accordion_content», que no existe en la página de
        // producto, y el botón no hacía nada. Va a la sección de pestañas (Descripción, Beneficios…) y abre
        // «Beneficios»; en las páginas que no tienen esa pestaña (24 de 31) abre «Descripción».
        if (!targetSection && targetId === 'accordion_content') {
          targetSection = document.querySelector('.shopify-section--accordion-content');
          if (targetSection) {
            const cmTabs = targetSection.querySelectorAll('details');
            const cmFind = function (txt) {
              return Array.prototype.find.call(cmTabs, function (dt) {
                const sm = dt.querySelector('summary');
                return sm && sm.textContent.trim().toLowerCase().indexOf(txt) === 0;
              });
            };
            const cmTab = cmFind('beneficios') || cmFind('descripci');
            if (cmTab && !cmTab.open) cmTab.querySelector('summary').click();
          }
        }
        if (targetSection) {
          // Remover active de todos los pills
          pills.forEach(p => p.classList.remove('active'));
          // Agregar active al pill clickeado
          pill.classList.add('active');
          
          // Calculamos la posición de la sección con el offset
          const sectionTop = targetSection.getBoundingClientRect().top + window.scrollY;
          
          // Scroll suave a la posición de la sección con el offset
          window.scrollTo({
            top: sectionTop - 120, // El valor de 80 puede ajustarse según el tamaño del elemento que cubre
            behavior: 'smooth'
          });
        }
      });
    });
  }


  /* ===============================
     CTA CLICK
  =============================== */

  function bindCTA() {
    document.addEventListener('click', function (e) {
      const btn = e.target.closest('#pdp-desktop-cta, #pdp-mobile-cta');
      if (!btn) return;
      e.preventDefault();

      const variantId = window.PDP_VARIANT_ID;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      })
      .then(res => {
        if (!res.ok) throw new Error('Add to cart failed');
        return res.json();
      })
      .then(item => {
        ['cart:refresh', 'cart:updated', 'cart:open'].forEach(evt => {
          document.dispatchEvent(new CustomEvent(evt, { detail: item }));
        });
        window.upcartRefreshCart();
      })
      .catch(console.error);
    });
  }

  /* ===============================
     INIT
  =============================== */
  function init() {
    updateCTA();
    observeSections();
    observeVariantInteraction();
    bindCTA();
    bindPillScroll();
  }

  init();
})();


(function () {
  const targetElement = document.querySelector('.product-info__buy-buttons');

  function onScroll() {
    if (!targetElement) return;

    const rect = targetElement.getBoundingClientRect();
    const targetOffsetTop = rect.top + window.scrollY;

    if (window.scrollY > 100) {
      document.body.classList.add('pdp-sticky-active');
    } else {
      document.body.classList.remove('pdp-sticky-active');
    }

    if (window.scrollY > targetOffsetTop) {
      document.body.classList.add('pdp-sticky-atc');
    } else {
      document.body.classList.remove('pdp-sticky-atc');
    }
  }

  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });
})();


setTimeout(function() {
  const gtyButton = document.querySelector('gty-whatsapp-chat-button');

  if (gtyButton && gtyButton.shadowRoot) {
    const gtyElement = gtyButton.shadowRoot.querySelector('.gty-wacb-wrapper');
    if (gtyElement) {
      gtyElement.style.bottom = '25px';
    }
  }
}, 3000);